import React, { Component } from 'react';
import { object, string, bool } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import KnowMoreModal from './../know-more-modal/KnowMoreModal';
import CheckoutButton from '../../../products/CheckoutButtonContainer';
import './ProductPickerInfo.css';


export default class ProductPickerInfo extends Component {
  static propTypes = {
    product: object,
    type: string,
    isFee: bool,
  };

  static defaultProps = {
    product: {},
    type: '',
    isFee: false,
  };

  constructor(props) {
    super(props);
    this.state = { isKnowMoreModalActive: false };
    this.toggleKnowMoreModal = this.toggleKnowMoreModal.bind(this);
  }

  toggleKnowMoreModal() {
    const isKnowMoreModalActive = !this.state.isKnowMoreModalActive;
    this.setState({ isKnowMoreModalActive });
  }

  render() {
    const {
      product, type, isFee,
    } = this.props;

    if (!Object.keys(product).length) return <div />;

    const { advantage, fullName } = product;
    return (
      <div className="product-picker-info">
        <div className="product-picker-info__title">{fullName}</div>

        <div className="product-picker-info__advantage">
          <div>
            <ReactMarkdown source={advantage.replace('visualizações', '')} />
          </div>
          {advantage.indexOf('visualizações') !== -1 && <div className="product-picker-info__advantage-text">visualizações</div>}
        </div>
        <CheckoutButton product={product} />
        <button className="product-picker-info__saibamais" onClick={this.toggleKnowMoreModal}>Saiba mais</button>
        <KnowMoreModal product={product} type={type} active={this.state.isKnowMoreModalActive} isFee={isFee} onClickClose={this.toggleKnowMoreModal} />
      </div>
    );
  }
}
